import React from "react";
import Modal from '../Modal'
import LoaderButton from "../LoaderButton";
import { checkTranslation, translate } from "../../utils/useful";
import FormViewer from "../FormViewer";
import SwitchInput from "../inputs/SwitchInput";
import TopicView from "../views/messenger/sideBar/TopicView";
import StagesManager from "../StagesManager";
import ImportModalFirst from "./ImportModalFirst";
import ImportModalSecond from "./ImportModalSecond";
import ImportModalThird from "./ImportModalThird";
import ImportModalForth from "./ImportModalForth";
import SwitchStyle1 from "../useful/SwitchButton";
import ButtonAnimated from "../buttons/ButtonAnimated";
import HttpServices from "../../utils/Http.services";


class MemoModal extends React.Component {
    state = {


        headers: [
            { key: 'memo', type: 'MultiContentInput', col: '12', information: { label: '{{lang}}Instant memo (optional)', placeholder: '{{lang}}Message ...', hint: '{{lang}}Instant memo will be reflected in the memos.', required: false } },

            {
                key: 'condition', type: 'SelectInput', col: '12', information: { type: "local", label: '{{lang}}How can see this memo', defaultValue: 'all', items: [{ title: 'All admins in all stages', value: 'all' }], placeholder: '{{lang}}Select ...', required: true },
                dependencies: [{
                    refKey: 'memo', targetKey: 'condition',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.memo' }, operator: { value: '!=' }, target: { value: null } } }, },
                        effect: { show: true, }
                    }],
                    else: { show: false },
                    init: true,
                }],
            },

            // { key: 'layout', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Layout', placeholder: '{{lang}}Landscape', required: true } },
            // { key: 'fieldsizing', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Feild sizing', placeholder: '{{lang}}Actual size', required: true } },
            // { key: 'fontsize', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Font size', placeholder: '{{lang}}Normal', required: true } },
        ],


    }

    open = () => {
        this.modal.showModal()
    }

    close = () => {
        this.modal.close()
    }


    submitActions = () => {
        this.props.updateStage()
    }
    

    render() {
        let options = this.state.options
        return (

            <Modal maxWidth={400} height={"100%"} ref={el => this.modal = el}>
                <div className="w-100 br-10 " style={{ backgroundColor: "white", overflow: 'hidden' }} >
                    {/* <div className='px-3 pt-2 position-sticky top-0 pb-2' style={{ borderBottom: '1px solid #eee' }}>
                        <p className="font-size-16 weight-500">{translate('Change stage')}</p>
                    </div> */}

                    <div className="px-3 mt-3">
                        <div className="br-4 px-2 py-2" style={{ border: '1px solid #eee' }}>
                            <p className="text-semibold text-small px-1">{translate("Change stage to")}</p>
                            <div className="flexc mt-2">
                                {/* <div className=" text-smaller br-20 text-semibold" style={{ padding: '7px 12px', background: 'rgb(241, 234, 255)' }}>
                                    <p >{translate("In progress")}</p>
                                </div> */}

                                <div className=" text-smaller br-20 text-semibold" style={{ padding: '7px 12px', background: '#f0f0f0' }}>
                                    <p >{translate("Dynamic stage")}</p>
                                </div>

                                <p className="mx-2 text-smaller text-semibold" style={{ color: 'rgb(0, 191, 96)' }}>{translate("Next stage")}</p>

                            </div>

                            <p className="text-smaller color-gray-2 mt-2 px-1 mb-1">{translate("Stage will be determinded after running the flow.")}</p>

                        </div>
                    </div>


                    <div className="mt-3 ">
                        <FormViewer ref={el => this.form = el} headers={this.state.headers} theme={"boreder-form"} inputClass={"bordered-input"} />
                    </div>

                    {/* <div className="mx-4 mt-4 br-15" style={{ backgroundColor: "#f6f6f6" }}>
                        <p className="p-3 font-size-12 weight-300">Create Completely custom print layouts whit the<span className="text-link"> page builder </span>feture.</p>
                    </div> */}
                    <div className="p-4 w-100 d-flex" style={{ justifyContent: "flex-end" }}>
                        <button className="gray-btn px-4 py-2 br-20 mx-2" onClick={() => this.modal.close()}>
                            <p className="font-size-14">{translate('Cancel')}</p>
                        </button>
                        {/* <button className="px-4 py-2 br-5 mld-4 purple-btn">
                            <p className="white font-size-14">{translate('Change stage')}</p>
                        </button> */}
                        <ButtonAnimated
                            iconwidth='24px'
                            icon='/assets/icons/angle-right-white2.svg'
                            onClick={() => { this.submitActions() }}
                            isLoading={this.state.isLoadingData}
                            title={translate('Change stage')}
                            textColor={'#fff'}
                            bg={this.props.background ?? ' linear-gradient(90deg, #5856D6, #7D7AFF)'}
                        />


                    </div>
                </div>
            </Modal>
        );

    }
}


export default MemoModal;
